// paths.js
const sectionPaths = [
  { id: "home", title: "HOME", path: "/", Width: "10%" },
  { id: "solutions", title: "SOLUTIONS", path: "/solutions", Width: "30%" },
  { id: "abha", title: "ABHA", path: "/abha", Width: "15%" },
  { id: "contactus", title: "CONTACT US", path: "/contactus", Width: "25%" },
];

export default sectionPaths;
